/* Cartec Essentials — robuuste in-pagina ankersprong.

   Probleem: een kale native <a href="#ce-reviews"> / <a href="#ce-safety">
   springt op het moment van klikken naar de dán berekende positie. Boven de
   review-/veiligheidssectie laadt daarna nog content na (product-media, de
   before/after-slider, de YouTube-video en de Judge.me-widget die pas
   client-side uitklapt). Die groeien in hoogte NADAT de sprong al gebeurd is,
   waardoor de eerste klik te hoog landt. Een tweede klik klopt wel, want dan
   staat alles al geladen.

   Twee valkuilen die hier meespelen en die deze aanpak afvangt:
   1. Op desktop (>=990px) is NIET het window de scroll-container, maar
      .page-wrapper (height:100dvh; overflow-y:auto). window.scrollTo doet daar
      dus niets — we zoeken de echte scroll-container van het doel op.
   2. Het thema zet globaal `scroll-behavior: smooth`. Daarom scrollen we via
      directe scrollTop-toewijzing (altijd instant).

   Aanpak: niet op tijd sturen (een stille netwerk-gap deed de vorige versie te
   vroeg stoppen), maar reageren op de ECHTE reflow. We lijnen het doel opnieuw
   uit bij elke DOM-mutatie en elke afbeelding/iframe die inlaadt, tot de
   gebruiker zelf scrollt of tot een harde tijdslimiet. Scope: alleen
   #ce-…-ankers (de Cartec-secties); Judge.me-, filter- en skip-links blijven
   ongemoeid. */
(function () {
  'use strict';

  var HEADER_OFFSET = 90; // gelijk aan scroll-margin-top van de secties
  var MAX_MS = 8000;      // harde bovengrens voor het meebewegen
  var BURST_MS = 1200;    // eerste fase: elk frame bijsturen (snelle vroege reflow)

  // Dichtstbijzijnde echt-scrollbare voorouder (bv. .page-wrapper op desktop),
  // anders null = het document/venster scrollt.
  function scrollParent(el) {
    var node = el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var oy = getComputedStyle(node).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function alignTo(target) {
    // Uitklap-element (bv. veiligheidsinformatie) meteen openen zodat de sprong
    // klopt en de inhoud direct zichtbaar is.
    var details = target.matches('details') ? target : target.querySelector('details');
    if (details && !details.open) details.open = true;

    var scroller = scrollParent(target);
    var docScroller = document.scrollingElement || document.documentElement;

    function desiredTop() {
      if (scroller) {
        var delta = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
        return Math.max(0, scroller.scrollTop + delta - HEADER_OFFSET);
      }
      return Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET);
    }

    function applyTop(y) {
      // Directe scrollTop = altijd instant (omzeilt scroll-behavior: smooth).
      if (scroller) scroller.scrollTop = y;
      else docScroller.scrollTop = y;
    }

    var done = false;
    var mo = null;
    var capTimer = null;

    function finish() {
      if (done) return;
      done = true;
      if (mo) mo.disconnect();
      if (capTimer) clearTimeout(capTimer);
      window.removeEventListener('wheel', onUser);
      window.removeEventListener('touchmove', onUser);
      window.removeEventListener('keydown', onUser);
      document.removeEventListener('load', onLoad, true);
    }

    // Zodra de gebruiker zelf scrollt/typt: stoppen met bijsturen (niet tegenwerken).
    function onUser() { finish(); }

    function realign() { if (!done) applyTop(desiredTop()); }

    // Meerdere mutaties/loads samenvoegen tot één uitlijning per frame.
    var pending = false;
    function scheduleRealign() {
      if (done || pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; realign(); });
    }

    function onLoad(e) {
      var t = e.target;
      if (t && (t.tagName === 'IMG' || t.tagName === 'IFRAME')) scheduleRealign();
    }

    window.addEventListener('wheel', onUser, { passive: true });
    window.addEventListener('touchmove', onUser, { passive: true });
    window.addEventListener('keydown', onUser);
    document.addEventListener('load', onLoad, true); // img/iframe (bubbelt niet)

    // Reageer op nazakkende content (Judge.me-hydratie, lazy media, enz.).
    if ('MutationObserver' in window) {
      mo = new MutationObserver(scheduleRealign);
      mo.observe(scroller || document.body, { childList: true, subtree: true });
    }

    // Eerste sprong + korte frame-voor-frame fase voor snelle vroege reflow.
    realign();
    var start = performance.now();
    (function burst(now) {
      if (done) return;
      realign();
      if (now - start < BURST_MS) requestAnimationFrame(burst);
    })(start);

    capTimer = setTimeout(finish, MAX_MS);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#ce-"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return; // onbekend anker: met rust laten (native gedrag)

    e.preventDefault();
    // URL bijwerken zodat het anker deelbaar/terugklikbaar blijft, zónder de
    // native sprong (pushState scrollt niet).
    if (window.history && history.pushState) {
      history.pushState(null, '', '#' + id);
    }
    alignTo(target);
  });
})();
